
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-page",
      function () {
        return require("private-next-pages/career-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-page"])
      });
    }
  